import { Route, Switch } from 'react-router-dom'
import { ROUTES } from 'routes'
import { TaxonomyTranslationDashboard } from './taxonomy-translation-dashboard'
import { TaxonomyTranslations } from './taxonomy-translations'

export const TaxonomyTranslationMapping = () => {
  return (
    <div className="h-full overflow-auto bg-[#FAFAFA]">
      <Switch>
        <Route
          path={ROUTES.TAXONOMY_TRANSLATION_DETAILS}
          component={TaxonomyTranslationDashboard}
        />
        <Route exact path={ROUTES.TAXONOMY_TRANSLATION} component={TaxonomyTranslations} />
      </Switch>
    </div>
  )
}
